<script setup lang="ts">
import { PhxsgAccordionTrigger as PhxsgCoreAccordionTrigger } from '@sg-core/src/View/Components/Molecules/Accordion';
import type { PhxsgAccordionTriggerProps } from '@sg-core/src/View/Components/Molecules/Accordion';

const { icon = { end: { id: 'chevron-down' } } } = defineProps<PhxsgAccordionTriggerProps>();
</script>

<template>
  <PhxsgCoreAccordionTrigger :icon="icon">
    <slot />
  </PhxsgCoreAccordionTrigger>
</template>
